module.exports = "/_next/static/images/balance-dashboard-big-5b2d54ee0a747cedb6c3847e07b89a08.svg";